/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { Container, Row, Col } from "react-bootstrap"
import * as wjRNav from "@grapecity/wijmo.react.nav"
import * as wjCNav from "@grapecity/wijmo.nav"
import { useCallback, useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import TenkoEditor from "./TenkoEditor"
import { e点呼区分 } from "../../../constant/enum/unko"
import TenkoService from "../../../service/truckcontrol/tenko/tenkoService"
import dayjs from "dayjs"
import CONSTANT from "../../../constant"

export type TTenkoUrlParam = {
  zyomuin_id: string
  date: string
  tenko_kbn: string
  tenko_count: string
}

/**
 * 点呼記録
 * @returns
 */
const TenkoRegister = () => {
  const {
    zyomuin_id: 乗務員ID,
    date: 日付,
    tenko_kbn: p点呼区分,
    tenko_count: 点呼回数Str,
  } = useParams<TTenkoUrlParam>()

  const 点呼回数 =
    !Number.isNaN(点呼回数Str) && parseInt(点呼回数Str) > 0
      ? parseInt(点呼回数Str)
      : 1

  // 初期タブ設定
  let firstIndex = (点呼回数 - 1) * 3
  switch (p点呼区分) {
    case e点呼区分.中間点呼１:
      firstIndex += 1
      break
    case e点呼区分.終業点呼:
      firstIndex += 2
      break
    default:
      break
  }

  const [selectedIndex, setSelectedIndex] = useState(firstIndex)
  const selectTab = (tabIndex: number) => {
    setSelectedIndex(tabIndex)
  }

  const [最大点呼回数, set最大点呼回数] = useState<number>(1)
  const [tabReloading, setTabReloading] = useState(false)

  /**
   * 最大点呼回数によるタブ生成処理
   */
  const get最大点呼回数関数 = useCallback(async () => {
    const res = await new TenkoService().getMaxTenkoCount({
      乗務員ID: parseInt(乗務員ID!),
      日付: dayjs(日付!).format("YYYY-MM-DD"),
    })

    set最大点呼回数(res.data)
  }, [firstIndex, 乗務員ID, 日付])

  // 選択者当日の最大点呼回数を取得する
  useEffect(() => {
    get最大点呼回数関数().then((e) => {
      setSelectedIndex(firstIndex)
    })
  }, [])

  useEffect(() => {
    if (!tabReloading) return
    get最大点呼回数関数().then((e) => {
      setTabReloading(false)
    })
  }, [tabReloading])

  return (
    <>
      <Container fluid>
        {/* 画面タイトル */}
        <Row className="page-title-row">
          <Col className="page-title-col">
            <span className="page-title">点呼記録</span>
          </Col>
        </Row>
        <Row>
          <Col>
            <wjRNav.TabPanel
              className={"no-background-color-tab"}
              selectedIndexChanged={(tabPanel: wjCNav.TabPanel) => {
                setSelectedIndex(tabPanel.selectedIndex)
              }}
              selectedIndex={selectedIndex}>
              {loopArray.map(
                ({
                  tabIndex,
                  点呼回数: tab点呼回数,
                  tagName,
                  点呼区分コード: tab点呼区分コード,
                }) => {
                  return (
                    <wjRNav.Tab
                      key={`tab_${tabIndex}`}
                      isVisible={最大点呼回数 >= tab点呼回数}>
                      <a className="tab-header">{tagName}</a>
                      <TenkoEditor
                        selfTabindex={tabIndex}
                        selectedIndex={selectedIndex}
                        tabChangeHandler={selectTab}
                        setTabReloading={setTabReloading}
                        点呼回数={tab点呼回数}
                        点呼区分コード={tab点呼区分コード}></TenkoEditor>
                    </wjRNav.Tab>
                  )
                }
              )}
            </wjRNav.TabPanel>
          </Col>
        </Row>
      </Container>
    </>
  )
}
export default TenkoRegister

let loopArray: {
  点呼回数: number
  tabIndex: number
  tagName: string
  点呼区分コード: string
}[] = []
//reactはmapでのみループが可能なためループ用のnumberを格納したArrayを作る
for (let index = 0; index < CONSTANT.登録可能最大点呼回数; index++) {
  loopArray.push({
    点呼回数: index + 1,
    tabIndex: index * 3,
    tagName: `始業点呼${index > 0 ? index + 1 : ""}`,
    点呼区分コード: e点呼区分.始業点呼,
  })
  loopArray.push({
    点呼回数: index + 1,
    tabIndex: index * 3 + 1,
    tagName: `中間点呼${index > 0 ? index + 1 : ""}`,
    点呼区分コード: e点呼区分.中間点呼１,
  })
  loopArray.push({
    点呼回数: index + 1,
    tabIndex: index * 3 + 2,
    tagName: `終業点呼${index > 0 ? index + 1 : ""}`,
    点呼区分コード: e点呼区分.終業点呼,
  })
}
